import script from "./Slideshow.vue?vue&type=script&setup=true&lang=js"
export * from "./Slideshow.vue?vue&type=script&setup=true&lang=js"

import "./Slideshow.vue?vue&type=style&index=0&id=06a4a394&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06a4a394"]])

export default __exports__